import { NavLink, Outlet, useLocation } from 'react-router-dom';

const ADMIN_NAV = [
  { grp: 'Overview' as const },
  { to: '/admin', label: 'Dashboard', icon: '▦', end: true },
  { grp: 'Platform' as const },
  { to: '/admin/system', label: 'System', icon: '⚙' },
  { to: '/admin/engines', label: 'Engines', icon: '⚡' },
  { grp: 'Integrations' as const },
  { to: '/admin/integrations', label: 'Integrations', icon: '✦' },
  { to: '/admin/data-feeds', label: 'Data Feeds', icon: '⇉' },
  { grp: 'Operations' as const },
  { to: '/admin/demo', label: 'Demo Controls', icon: '◉' },
  { grp: 'Identity & RBAC' as const },
  { to: '/admin/users', label: 'Users & Roles', icon: '☰' },
  { to: '/admin/owners', label: 'Owners', icon: '◈' },
  { to: '/admin/audit', label: 'Audit Trail', icon: '❏' },
  { to: '/admin/method-registry', label: 'Method Registry', icon: '⚿' },
];

export default function AdminShell() {
  const location = useLocation();
  const isActive = (to: string, end?: boolean) =>
    end ? location.pathname === to : location.pathname.startsWith(to);

  return (
    <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start' }}>
      <aside
        style={{
          width: 220,
          flexShrink: 0,
          background: 'linear-gradient(180deg, var(--panel), var(--panel2))',
          border: '1px solid var(--line)',
          borderRadius: 12,
          padding: '20px 14px',
          position: 'sticky',
          top: 24,
        }}
      >
        <div className="ph" style={{ marginBottom: 14 }}>Admin</div>
        {ADMIN_NAV.map((item, i) =>
          'grp' in item ? (
            <div className="nav-grp" key={`grp-${i}`}>{item.grp}</div>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '8px 10px',
                borderRadius: 7,
                fontSize: 14,
                textDecoration: 'none',
                color: isActive(item.to, item.end) ? 'var(--ink)' : 'var(--muted)',
                background: isActive(item.to, item.end) ? 'linear-gradient(90deg, rgba(224,138,43,.16), transparent)' : 'transparent',
                boxShadow: isActive(item.to, item.end) ? 'inset 2px 0 0 var(--amber)' : 'none',
                marginBottom: 2,
              }}
            >
              <span style={{ width: 16, textAlign: 'center', opacity: 0.85, fontSize: 14 }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ),
        )}
      </aside>
      <div style={{ flex: 1, minWidth: 0 }}>
        <Outlet />
      </div>
    </div>
  );
}
